/**
 * 30 last character of a base64-encoded fallback image used to detect legacy error image.
 *
 * This image is typically returned from older TimeClock when the photo image is missing because of camera permission or
 * the device has no camera at all.
 * It is used for comparison (eg: useFallbackImageErrorCheck)
 * We use the last 30 characters for a lightweight comparison.
 * @constant {string}
 */
export const BASE64_FALLBACK_ERROR_IMG_TIME_CLOCK =
  'MrMDA6MDARJDMQAAAAAElFTkSuQmCC'
